import React from "react";
import {useTooltip} from "@widgets/tooltip/TooltipProvider";

type Props = {
    description: string,
};

const DescriptionFormatter = ({description}: Props) => {
    const {applyTooltip} = useTooltip();

    return (
        <p
            className={"w-fit max-w-[300px] overflow-hidden text-ellipsis"}
            {...applyTooltip(description)}
        >
            {description}
        </p>
    );
};

export default DescriptionFormatter;